<template>
  <div>
    <h5 v-if="campaign_id != null && campaign_id != ''">
      <em>{{ campaign_dates }}</em>
    </h5>

    <template v-for="type in types">
      <div
        v-for="question in getQuestions(type)"
        class="row"
      >
        <component
          :is="componentName(type)"
          :question="question"
          style="page-break-after:always;"
        />
      </div>
    </template>
  </div>
</template>

<script>

import FiveScaleLecturerAnalytics from './FiveScale/LecturerAnalytics'
import SixScaleLecturerAnalytics from './SixScale/LecturerAnalytics'
import OpenLecturerAnalytics from './Open/OpenLecturerAnalytics'
import { defaultErrorMessage } from '@/helpers'

export default {
  name: 'ReviewLecturerAnalytics',

  components: { FiveScaleLecturerAnalytics, SixScaleLecturerAnalytics, OpenLecturerAnalytics },

  props: {
    lecturer_id: { required: true },
    campaign_id: { required: true },
    lecturer_name: { required: true },
    campaign_name: { required: true },
    campaign_start: { required: true },
    campaign_end: { required: true },
    prop_questions: { required: false, default: null },
  },

  data () {
    return {
      types: [],
      questions: {},
    }
  },

  computed: {
    campaign_dates () {
      return moment(this.campaign_start).format('DD-MM-YYYY') + ' / ' + moment(this.campaign_end).format('DD-MM-YYYY')
    },
  },

  mounted () {
    if (this.prop_questions == null) {
      axios.get('/review/analytics/questions', {
        params: {
          lecturer: this.lecturer_id,
          category: 'all',
          campaign: this.campaign_id,
          own: false,
        },
      }).then(({ data }) => {
        this.questions = data.data.data
        this.questions = Object.values(this.questions).filter(question => {
          return question.type === 'five_scale' || question.type === 'six_scale'
        })
        this.types = Object.values(Object.values(this.questions).reduce((total, current) => {
          return Object.assign(total, {
            [current.type]: current.type,
          })
        }, {}))
      }).catch(error => defaultErrorMessage(error))
    } else {
      this.questions = JSON.parse(this.prop_questions)

      this.types = Object.values(Object.values(this.questions).reduce((total, current) => {
        return Object.assign(total, {
          [current.type]: current.type,
        })
      }, {}))
    }
  },

  methods: {
    componentName (typeName) {
      if (typeName === 'like') {
        return 'LikeLecturerAnalytics'
      } else if (typeName === 'five_scale') {
        return 'FiveScaleLecturerAnalytics'
      } else if (typeName === 'six_scale') {
        return 'SixScaleLecturerAnalytics'
      } else if (typeName === 'open') {
        return 'OpenLecturerAnalytics'
      }
    },

    getQuestions (type) {
      return Object.values(this.questions).filter(question => {
        return question.type === type
      })
    },
  },
}
</script>

<style scoped>

</style>
